import React from "react";
import "./OurFeatures.css";
import { IoIosContacts } from "react-icons/io";
import { TiMessages } from "react-icons/ti";
import { FaWpforms } from "react-icons/fa";
import { TbSettingsAutomation } from "react-icons/tb";
import { GrCatalog } from "react-icons/gr";
import { GiArtificialIntelligence } from "react-icons/gi";
import { RiCustomerService2Line } from "react-icons/ri";
import { TfiWidget } from "react-icons/tfi";
import { SiAwsorganizations } from "react-icons/si";
import { MdOutlineCampaign } from "react-icons/md";

const features = [
  {
    title: "CRM חכם לניהול אנשי קשר",
    desc: "ניהול מלא של לקוחות בטבלת אנשי קשר מתקדמת: סיווג לפי תגיות, הוספת שדות מותאמים אישית, וציר זמן דינמי לתיעוד כל אינטראקציה — כולל קבצי מדיה והערות.",
    icon: <IoIosContacts />,
  },
  {
    title: "ניהול תבניות WhatsApp מתקדם",
    desc: "יצירה, עריכה ושליחה של תבניות WhatsApp עם משתנים, טקסטים, תמונות, וידאו, מיקומים וכפתורים אינטרקטיביים — מותאם למערכת Meta בצורה מלאה.",
    icon: <TiMessages />,
  },
  {
    title: "טפסים חכמים בווטסאפ (Flows)",
    desc: "בנו טפסים דינמיים ומסכים אינטראקטיביים שזורמים ישירות בתוך הוואטסאפ של הלקוח, כולל קליטת נתונים ושליחה למערכות חיצוניות ב-API.",
    icon: <FaWpforms />,
  },
  {
    title: "אוטומציות מתקדמות ובוטים חכמים",
    desc : "צרו בקלות בוט שמגיב אוטומטית ללקוחות לפי טריגרים חכמים, בצעו פעולות דינמיות כמו שליחת נתונים ל-CRM או קבלת מידע במערכות חיצוניות בקליק",
    // desc: "הגיבו אוטומטית ללקוחות עם בוטים לפי טריגרים חכמים, בצעו פעולות דינמיות כמו שליחת נתונים ל-CRM או קבלת מידע במערכות חיצוניות בקליק.",
    icon: <TbSettingsAutomation />,
  },
  {
    title: "קטלוגים ומכירה ישירה בווטסאפ",
    desc: "הקימו חנות דיגיטלית ישירות בתוך השיחה: שלחו קטלוג מוצרים ללקוח, אפשרו לו לבחור מוצרים ולהרכיב סל קניות — עם אפשרות להזמנה אוטומטית מלאה. כל מה שנשאר לכם? רק לספק את המוצר!",
    icon: <GrCatalog />,
  },
  {
    title: "מודל AI מבוסס מאגר ידע",
    desc: "בנו מודל בינה מלאכותית חכם המבוסס על מאגר המידע שלכם: המערכת שולפת תשובות מדויקות לשאלות לקוחות לפי התוכן שהזנתם — עם שליטה מלאה על השפה והטון.",
    icon: <GiArtificialIntelligence />,
  },
  {
    title: "מרכז שיחות רב-נציגים בזמן אמת",
    desc: "נהלו שיחות וואטסאפ עם לקוחות דרך מספר נציגים במקביל — בלי מגבלת מכשיר אחד! כל שיחה מסודרת לפי סטטוס, נושא והערות פנימיות, לניהול לקוחות חכם ויעיל יותר מכל מקום.",
    icon: <RiCustomerService2Line />,
  },
  {
    title: "מערכת קמפיינים ודיוור אוטומטי",
    desc: "שליחת הודעות אישיות מותאמות לאלפי לקוחות בקליק — לפי פילטרים, תגיות, ותזמון אוטומטי לקמפיינים אפקטיביים שמגיעים בדיוק למי שצריך.",
    icon: <MdOutlineCampaign />,
  },
  {
    title: "פתיחת חשבון WhatsApp API מקצועית",
    desc: "הקימו חשבון WhatsApp API דרך שותף רשמי בתהליך מהיר ומודרך, נהלו את פרופיל העסק והתחילו לעבוד בוואטסאפ העסקי כמו מקצוענים תוך ימים בודדים.",
    icon: <SiAwsorganizations />,
  },
];

const OurFeatures = () => {
  return (
    <div className="our-features-container">
      <h2 className="our-features-header">הפיצ'רים שלנו</h2>
      <div className="our-features-grid">
        {features.map((feature, index) => (
          <div className="feature-box" key={index}>
            <div className="feature-icon">{feature.icon}</div>
            <div className="feature-content">
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-desc">{feature.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurFeatures;
